"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../types/General");
const appStateSelectProjectId_1 = __importDefault(require("./appStateSelectProjectId"));
const buildDebouncedFunction_1 = __importDefault(require("./buildDebouncedFunction"));
const clientProjectEnvVariableGetNameOnSystem_1 = __importDefault(require("./clientProjectEnvVariableGetNameOnSystem"));
const recordAt_1 = __importDefault(require("./recordAt"));
const cache = {};
const requestAndUpdateCache = (0, buildDebouncedFunction_1.default)(5000, async ({ requestDevEnvVariableFromNetwork, name, projectId, }) => {
    const valueInNetwork = await requestDevEnvVariableFromNetwork({
        name,
        projectId,
    });
    cache[name] = valueInNetwork;
    return valueInNetwork;
});
const entryVarEnvironmentVariableEvaluate = async ({ entryVar, store, isDevelopment, requestDevEnvVariableFromNetwork, }) => {
    const name = entryVar[General_1.DEFINITION_PROP_NAMES.NAME];
    if (!name) {
        return undefined;
    }
    const projectId = (0, appStateSelectProjectId_1.default)(store.getState());
    if (isDevelopment) {
        const valueInCache = (0, recordAt_1.default)(cache, name);
        if (valueInCache) {
            requestAndUpdateCache({
                name,
                projectId,
                requestDevEnvVariableFromNetwork,
            });
            return valueInCache;
        }
        const devValue = await requestDevEnvVariableFromNetwork({
            name,
            projectId,
        });
        cache[name] = devValue;
        return devValue;
    }
    return process.env[(0, clientProjectEnvVariableGetNameOnSystem_1.default)({
        name,
        projectId,
    })];
};
exports.default = entryVarEnvironmentVariableEvaluate;
